// src/pages/PlaylistsPage.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
    getPlaylists,
    createPlaylist,
    copyPlaylist as apiCopyPlaylist,
} from "../api/api";
import "./PlaylistsPage.scss";

export default function PlaylistsPage() {
    const [playlists, setPlaylists] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [newTitlePlaylist, setNewTitlePlaylist] = useState("");
    const [loading, setLoading] = useState(false);
    const [creating, setCreating] = useState(false);
    const [isOrderChanged, setIsOrderChanged] = useState(false);

    useEffect(() => {
        loadPlaylists();
    }, []);

    function loadPlaylists() {
        setLoading(true);
        getPlaylists()
            .then((data) => setPlaylists(Array.isArray(data) ? data : []))
            .catch((e) => alert(`Ошибка загрузки: ${e.message || e}`))
            .finally(() => setLoading(false));
    }

    function openModalNewPlaylist() {
        setIsOpenModal(true);
        setNewTitlePlaylist("");
    }

    function createNew() {
        if (!newTitlePlaylist.trim()) return;
        setCreating(true);
        createPlaylist({ title: newTitlePlaylist.trim() })
            .then(() => {
                setNewTitlePlaylist("");
                setIsOpenModal(false);
                loadPlaylists();
            })
            .catch((e) => alert(`Ошибка создания: ${e.message || e}`))
            .finally(() => setCreating(false));
    }

    async function copyPlaylist(id) {
        const title = prompt("Название для копии плейлиста:", "");
        try {
            await apiCopyPlaylist(id, title ? { title } : {});
            loadPlaylists();
        } catch (e) {
            alert(`Ошибка копирования: ${e.message || e}`);
        }
    }

    function handleDragEnd(result) {
        if (!result.destination) return;
        const reordered = Array.from(playlists);
        const [removed] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, removed);
        setPlaylists(reordered);
        setIsOrderChanged(true);
    }

    function saveOrder() {
        alert(
            "Сохранение порядка списка плейлистов не поддержано API. Перетасовка действует только локально. " +
            "Порядок файлов внутри конкретного плейлиста сохраняется на его странице."
        );
        setIsOrderChanged(false);
    }

    return (
        <div className="playlists-page">
            {isOpenModal && (
                <div className="modal-overlay" onClick={() => setIsOpenModal(false)}>
                    <div className="modal-window" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-title">Новый плейлист</div>
                        <input
                            className="modal-input"
                            autoFocus
                            placeholder="Название"
                            value={newTitlePlaylist}
                            onChange={(e) => setNewTitlePlaylist(e.target.value)}
                        />
                        <div className="modal-actions">
                            <button
                                type="button"
                                className="modal-btn cancel"
                                onClick={() => setIsOpenModal(false)}
                            >
                                Отмена
                            </button>
                            <button
                                type="button"
                                className="modal-btn primary"
                                disabled={!newTitlePlaylist.trim() || creating}
                                onClick={createNew}
                            >
                                {creating ? "Создаём..." : "Создать"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div className="playlist-head">
                <h2>Плейлисты</h2>
                <button className="playlist-add-btn" onClick={openModalNewPlaylist}>
                    <span>＋</span> Новый плейлист
                </button>
            </div>

            {isOrderChanged && (
                <div className="playlist-order-changed">
                    <button onClick={saveOrder} className="playlist-order-save-btn">
                        Сохранить порядок
                    </button>
                    <span className="playlist-order-tip">
            Перемести и нажми &quot;Сохранить порядок&quot;
          </span>
                </div>
            )}

            {loading && <div className="playlist-loading">Загрузка...</div>}

            <div className="playlist-list">
                <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="playlist-droppable">
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="playlist-droppable"
                            >
                                {!loading && playlists.length === 0 && (
                                    <div className="playlist-empty">Нет плейлистов</div>
                                )}

                                {playlists.map((el, idx) => (
                                    <Draggable
                                        draggableId={String(el.id)}
                                        index={idx}
                                        key={el.id}
                                    >
                                        {(providedDraggable, snapshot) => (
                                            <div
                                                className={`playlist-card${
                                                    snapshot.isDragging ? " dragging" : ""
                                                }`}
                                                ref={providedDraggable.innerRef}
                                                {...providedDraggable.draggableProps}
                                                {...providedDraggable.dragHandleProps}
                                            >
                                                <div className="playlist-card-title">
                                                    <Link to={`detail/${el.id}`}>{el.title}</Link>
                                                </div>
                                                <div className="playlist-card-info">
                          <span>
                            Подключено устройств: {el.activeDevice ?? 0}
                          </span>
                                                </div>
                                                <div className="playlist-card-actions">
                                                    <button
                                                        className="playlist-copy-btn"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            copyPlaylist(el.id);
                                                        }}
                                                    >
                                                        Копировать
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </Draggable>
                                ))}

                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>
        </div>
    );
}
